import { BaseService } from '#services/BaseService';

class BlackListService extends BaseService {
  constructor() {
    super('/black-list');
    if (!BlackListService.instance) {
      BlackListService.instance = this;
    }
    return BlackListService.instance;
  }
}

const instance = new BlackListService();
Object.freeze(instance);

export default instance;
